import { render, staticRenderFns } from "./LoadTypeDonut.vue?vue&type=template&id=70e61a3b&scoped=true"
import script from "./LoadTypeDonut.vue?vue&type=script&lang=js"
export * from "./LoadTypeDonut.vue?vue&type=script&lang=js"
import style0 from "./LoadTypeDonut.vue?vue&type=style&index=0&id=70e61a3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e61a3b",
  null
  
)

export default component.exports